import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "siteBtn",
    "workerBtn",
    "siteSelector",
    "workerSelector",
    "tableBody",
    "month",
    "dateHeader",
    "detailPanel",
    "detailDate",
    "detailSite",
    "detailWorker",
    "selectSite"
  ]

  connect() {
    this.setCurrentMonth()
    this.renderSiteMode()
    this.updateCalendar()
    this.hideDetail()
  }

  showSite() {
    this.renderSiteMode()
    this.updateCalendar()
    this.hideDetail()
  }

  showWorker() {
    this.renderWorkerMode()
    this.updateCalendar()
    this.hideDetail()
  }

  selectorChange() {
    this.hideDetail()
  }

  updateMonth() {
    this.updateCalendar()
    this.hideDetail()
  }

  renderSiteMode() {
    this.mode = 'site'
    this.isWorkerMode = false
    this.activate(this.siteBtnTarget, this.workerBtnTarget)

    this.siteSelectorTarget.style.display = ""
    this.workerSelectorTarget.style.display = "none"

    this.currentNames = ["佐藤", "鈴木", "高橋"]
  }

  renderWorkerMode() {
    this.mode = 'worker'
    this.isWorkerMode = true

    this.activate(this.workerBtnTarget, this.siteBtnTarget)

    this.siteSelectorTarget.style.display = "none"
    this.workerSelectorTarget.style.display = ""

    this.currentNames = ["東京現場", "大阪現場", "名古屋現場"]
  }

  updateCalendar() {
    if (!this.monthTarget.value) return

    const [year, month] = this.monthTarget.value.split("-").map(Number)
    const days = this.daysInMonth(year, month)

    this.renderDateHeader(days)
    this.renderRows(this.currentNames, days)
  }

  renderDateHeader(days) {
    const title = this.mode === "site" ? "作業員" : "現場"
    this.dateHeaderTarget.innerHTML = `
      <th class="sticky-left name-col">${title}</th>
      <th>人工合計</th>
      ${Array.from({ length: days }, (_, i) => `<th>${i + 1}</th>`).join("")}
    `
  }

  renderRows(names, days) {
    this.tableBodyTarget.innerHTML = ""

    names.forEach(name => {
      const tr = document.createElement("tr")

      tr.innerHTML = `
        <td class="sticky-left name-col">${name}</td>
        <td></td>
        ${Array.from({ length: days }, () => `<td class="matrix-cell"></td>`).join("")}
      `

      this.tableBodyTarget.appendChild(tr)
    })
  }

  cellClick(event) {
    const td = event.target.closest("td")
    if (!td) return

    if (td.classList.contains("name-col")) return

    const tr = td.closest("tr")
    const table = td.closest("table")

    const colIndex = td.cellIndex
    if (colIndex < 2) return

    const th = table.querySelector(
        `thead th:nth-child(${colIndex + 1})`
    )
    const day = th?.textContent?.trim()

    const month = this.monthTarget.value
    const date = month && day ? `${month}-${day.padStart(2, "0")}` : ""

    let siteName = ""
    let workerName = ""

    if (this.mode === "site") {
      siteName = this.siteSelectorTarget.querySelector("select").selectedOptions[0]?.text
      workerName = tr.querySelector(".name-col")?.textContent
    } else {
      workerName = this.workerSelectorTarget.querySelector("select").selectedOptions[0]?.text
      siteName = tr.querySelector(".name-col")?.textContent
    }

    this.showDetail({
      date,
      siteName,
      workerName
    })
  }

  showDetail({ date, siteName, workerName }) {
    this.detailDateTarget.textContent = date
    this.detailSiteTarget.textContent = siteName
    this.detailWorkerTarget.textContent = workerName

    this.detailPanelTarget.style.display = "block"
  }

  hideDetail() {
    this.detailPanelTarget.style.display = "none"
  }


  setCurrentMonth() {
    const now = new Date()
    const yyyy = now.getFullYear()
    const mm = String(now.getMonth() + 1).padStart(2, "0")
    this.monthTarget.value = `${yyyy}-${mm}`
  }

  daysInMonth(year, month) {
    return new Date(year, month, 0).getDate()
  }

  activate(activeBtn, inactiveBtn) {
    activeBtn.classList.add("active")
    inactiveBtn.classList.remove("active")
  }
}
